import { useEffect } from 'react'

import { useAppSelector, useAppDispatch } from './hooks'
import {
  getUserState,
  queryUser
} from './features/user/userSlice'

import { initLocalData } from './features/trackLocal/trackLocalSlice'

// import styles from './Counter.module.css'

function InitStore() {
  const dispatch = useAppDispatch()

  const UserState = useAppSelector(getUserState)
  
  useEffect(() => {
    // 初始化本地缓存
    dispatch(initLocalData())
    // 初始化请求用户信息
    if (UserState.status === 'loading') {
      // console.log('redux - getuserInfo')
      dispatch(queryUser())
    }
  }, [])
  

  return (
    <></>
  )
}

export default InitStore
